import isPresent from './is_present';

export default function formattedRoundNumber(number) {
  if (isPresent(number)) {
    const roundedNumber = Math.round(number / 100) * 100;
    return `more than ${roundedNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
  }
}